import { locationApi } from "@/services/api/locations.api";
import appSnackbarService from "@/services/appSnackbar.service";

interface LocationRequest {
  sortBy: string;
  descending: string;
  page: number;
  rowsPerPage: number;
  searchString: string[];
}

interface LocationPost {
  data: object;
  index: number;
}

interface LocationDelete {
  id: number;
  index: number;
}

export const locationsState: any = {
  namespaced: false,
  state: {
    locations: [],
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false
  },
  mutations: {
    // load surveyMaterials
    LOCATION_FETCH_SUCCESS(state: any, payload: any) {
      state.locations = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
    },
    LOCATION_FETCH_START(state: any) {
      state.fetching = true;
    },
    LOCATION_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // save
    LOCATION_SAVE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        // letörli a (payload.index)-ű elemet
        state.locations.splice(payload.index, 1, payload.data);
      } else {
        // add
        state.locations.push(payload.data);
      }
    },
    LOCATION_SAVE_START(state: any) {
      state.fetching = true;
    },
    LOCATION_SAVE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
    },

    // delete
    LOCATION_DELETE_SUCCESS(state: any, payload: any) {
      if (payload.index > -1) {
        // update
        state.locations.splice(payload.index, 1);
        state.loading = false;
      }
    },
    LOCATION_DELETE_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    LOCATION_DELETE_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.error = payload;
      state.loading = false;
    },
  },
  actions: {
    getLocations({ commit }: any, request: LocationRequest) {
      commit("LOCATION_FETCH_START");
      locationApi
        .getAll(request)
        .then(response => {
          commit("LOCATION_FETCH_SUCCESS", response.data);
        })
        .catch(error => {
          commit("LOCATION_FETCH_ERROR", error);
        });
    },
    saveLocation({ commit }: any, payload: LocationPost) {
      commit("LOCATION_SAVE_START");
      const editedIndex = payload.index;

      const promise = new Promise((resolve, reject) => {
        locationApi
          .save(payload.data)
          .then(response => {
            commit("LOCATION_SAVE_SUCCESS", {
              data: response.data,
              index: editedIndex
            });
            appSnackbarService.success("Helység sikeresen mentve!");
            resolve(response);
          })
          .catch(error => {
            commit("LOCATION_SAVE_ERROR", error);
            // appSnackbarService.error(error);
            reject(error);
          });
        });
      return promise;
    },
    deleteLocation({ commit }: any, payload: LocationDelete) {
      commit("LOCATION_DELETE_START");

      const deletedIndex = payload.index;
      locationApi
        .delete(payload.id)
        .then(response => {
          commit("LOCATION_DELETE_SUCCESS", {
            data: response.data,
            index: deletedIndex
          });
          appSnackbarService.warning("Success deleting Location!");
        })
        .catch(error => {
          commit("LOCATION_DELETE_ERROR", error);
          // appSnackbarService.error(error);
        });
    },
  }
};
